// 竞赛id
export const COMPET_ID = ''

// 竞赛字典code
export const COMPET_CODE = 'technology'

// 竞赛分类id
export const COMPET_CLASSIFY_ID = 5

// 接口前缀
export const PREFIX_API =  '/admin-api/'

// 竞赛主题名称
export const COMPET_NAME = '蓝桥青少科技素养科普活动'

// 届数
export const SESSIONS_NUMBER = '第十四届'

// 主题颜色
export const COMPET_THEME = '#117AC9'

// 底部备案号
export const FILING_NUMBER = '鲁ICP备2022031800号-1'



// WEBPACK FOOTER //
// ./src/utils/config.js